import { render, staticRenderFns } from "./IDCardZAMCHEMA.vue?vue&type=template&id=750050aa&scoped=true&"
import script from "./IDCardZAMCHEMA.vue?vue&type=script&lang=js&"
export * from "./IDCardZAMCHEMA.vue?vue&type=script&lang=js&"
import style0 from "./IDCardZAMCHEMA.vue?vue&type=style&index=0&id=750050aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750050aa",
  null
  
)

export default component.exports